import { createFeature, createReducer, on } from '@ngrx/store';
import { UsersListActions } from './users-list.actions';
import { UsersListFeatureState } from './users-list.models';

export const initialUsersListState: UsersListFeatureState = {
  filters: {
    name: null,
    email: null,
    phone: null,
    roleId: null,
    roleLabel: null,
    managerId: null,
    managerLabel: null,
    joiningDate: null,
    status: true
  },
  pagination: {
    firstRowOffset: 0,
    pageSize: 10,
    page: 1,
    totalRecords: 0
  },
  sort: {
    sortField: null,
    sortOrder: 1,
    previousSortField: null,
    previousSortOrder: 0
  },
  gridData: null
};

const reducer = createReducer(
  initialUsersListState,
  on(UsersListActions.snapshotPersisted, (state, { snapshot }) => ({
    ...state,
    filters: snapshot.filters,
    pagination: snapshot.pagination,
    sort: snapshot.sort
  })),
  on(UsersListActions.gridDataCached, (state, { gridData }) => ({
    ...state,
    gridData
  })),
  on(UsersListActions.gridDataCleared, (state) => ({
    ...state,
    gridData: null
  })),
  on(UsersListActions.cleared, () => initialUsersListState)
);

export const usersListFeature = createFeature({
  name: 'usersList',
  reducer
});
